"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _classnames6 = _interopRequireDefault(require("classnames"));

var _Drawer = _interopRequireDefault(require("@material-ui/core/Drawer"));

var _styles = _interopRequireDefault(require("./styles"));

var _useIsBreakpointDown = _interopRequireDefault(require("../../hooks/useIsBreakpointDown"));

var _Footer = _interopRequireDefault(require("../Footer"));

var _AppBar = _interopRequireDefault(require("../AppBar"));

var _LayoutActions = _interopRequireDefault(require("./LayoutActions"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // FIXME remove once material-ui drawer style is fixed


var isDocked = function isDocked(type) {
  return type === 'permanent' || type === 'persistent';
}; // TODO refactor all smallScreen logic
// TODO smallScreen logic should be named xSmallScreen logic


var useDrawerState = function useDrawerState(open, setOpen) {
  var state = React.useState(false);
  return open === undefined || !setOpen ? state : [open, setOpen];
};

var Layout = function Layout(_ref) {
  var _classnames, _classnames2, _classnames4, _classnames5;

  var classes = _ref.classes,
      children = _ref.children,
      appBarContent = _ref.appBarContent,
      appBarPosition = _ref.appBarPosition,
      appBarProps = _ref.appBarProps,
      mainGrow = _ref.mainGrow,
      props$leftDrawerOpen = _ref.leftDrawerOpen,
      onLeftDrawerOpenChange = _ref.onLeftDrawerOpenChange,
      leftDrawerContent = _ref.leftDrawerContent,
      leftDrawerType = _ref.leftDrawerType,
      leftDrawerUnder = _ref.leftDrawerUnder,
      leftDrawerProps = _ref.leftDrawerProps,
      props$rightDrawerOpen = _ref.rightDrawerOpen,
      onRightDrawerOpenChange = _ref.onRightDrawerOpenChange,
      rightDrawerContent = _ref.rightDrawerContent,
      rightDrawerType = _ref.rightDrawerType,
      rightDrawerUnder = _ref.rightDrawerUnder,
      rightDrawerProps = _ref.rightDrawerProps,
      footerContent = _ref.footerContent,
      stickyFooter = _ref.stickyFooter,
      footerProps = _ref.footerProps,
      usingTwoRowAppBar = _ref.usingTwoRowAppBar,
      breakpoint = _ref.breakpoint;
  var smallScreen = (0, _useIsBreakpointDown.default)(breakpoint);

  var _useDrawerState = useDrawerState(props$leftDrawerOpen, onLeftDrawerOpenChange),
      _useDrawerState2 = _slicedToArray(_useDrawerState, 2),
      leftDrawerOpen = _useDrawerState2[0],
      setLeftDrawerOpen = _useDrawerState2[1];

  var _useDrawerState3 = useDrawerState(props$rightDrawerOpen, onRightDrawerOpenChange),
      _useDrawerState4 = _slicedToArray(_useDrawerState3, 2),
      rightDrawerOpen = _useDrawerState4[0],
      setRightDrawerOpen = _useDrawerState4[1];

  var handleLeftDrawerClose = React.useCallback(function () {
    if (!setLeftDrawerOpen) return;
    setLeftDrawerOpen(false);
  }, [setLeftDrawerOpen]);
  var toggleLeftDrawer = React.useCallback(function () {
    if (!setLeftDrawerOpen) return;
    setLeftDrawerOpen(!leftDrawerOpen);
  }, [leftDrawerOpen, setLeftDrawerOpen]);
  var handleRightDrawerClose = React.useCallback(function () {
    if (!setRightDrawerOpen) return;
    setRightDrawerOpen(false);
  }, [setRightDrawerOpen]);
  var toggleRightDrawer = React.useCallback(function () {
    if (!setRightDrawerOpen) return;
    setRightDrawerOpen(!rightDrawerOpen);
  }, [setRightDrawerOpen, rightDrawerOpen]);
  var layoutActions = React.useMemo(function () {
    return {
      handleLeftDrawerClose: handleLeftDrawerClose,
      toggleLeftDrawer: toggleLeftDrawer,
      handleRightDrawerClose: handleRightDrawerClose,
      toggleRightDrawer: toggleRightDrawer
    };
  }, [handleLeftDrawerClose, toggleLeftDrawer, handleRightDrawerClose, toggleRightDrawer]);
  var mainLeftShift = !smallScreen && (leftDrawerType === 'permanent' || leftDrawerOpen && leftDrawerType === 'persistent');
  var mainRightShift = !smallScreen && (rightDrawerType === 'permanent' || rightDrawerOpen && rightDrawerType === 'persistent');
  var mainClassnames = (0, _classnames6.default)(classes.main, (_classnames = {}, _defineProperty(_classnames, "".concat(classes.mainFixedAppBar), appBarContent && appBarPosition === 'fixed' && !usingTwoRowAppBar), _defineProperty(_classnames, "".concat(classes.mainFixedTwoRowAppBar), appBarContent && appBarPosition === 'fixed' && usingTwoRowAppBar), _defineProperty(_classnames, "".concat(classes.mainGrow), mainGrow && !usingTwoRowAppBar), _defineProperty(_classnames, "".concat(classes.mainGrowTwoRowAppBar), mainGrow && usingTwoRowAppBar), _defineProperty(_classnames, "".concat(classes.mainStickyFooter), stickyFooter), _defineProperty(_classnames, "".concat(classes.mainShift), mainLeftShift || mainRightShift), _defineProperty(_classnames, "".concat(classes.mainLeftShift), mainLeftShift), _defineProperty(_classnames, "".concat(classes.mainRightShift), mainRightShift), _defineProperty(_classnames, "".concat(classes.mainLeftRightShift), mainLeftShift && mainRightShift), _classnames));
  var footerClassnames = (0, _classnames6.default)(classes.footer, footerProps ? footerProps.className : '');
  var appBarLeftShift = !smallScreen && !leftDrawerUnder && (leftDrawerOpen && leftDrawerType === 'persistent' || leftDrawerType === 'permanent');
  var appBarRightShift = !smallScreen && !rightDrawerUnder && (rightDrawerOpen && rightDrawerType === 'persistent' || rightDrawerType === 'permanent');
  var appBarClassnames = (0, _classnames6.default)(classes.appBar, (_classnames2 = {}, _defineProperty(_classnames2, "".concat(classes.appBarShift), appBarLeftShift || appBarRightShift), _defineProperty(_classnames2, "".concat(classes.appBarLeftShift), appBarLeftShift), _defineProperty(_classnames2, "".concat(classes.appBarRightShift), appBarRightShift), _defineProperty(_classnames2, "".concat(classes.appBarLeftRightShift), appBarLeftShift && appBarRightShift), _classnames2));
  var leftDrawerPaperClassnames = (0, _classnames6.default)(classes.drawerPaper, _defineProperty({}, "".concat(classes.drawerPaperUnder), !smallScreen && leftDrawerUnder));
  var rightDrawerPaperClassnames = (0, _classnames6.default)(classes.drawerPaper, (_classnames4 = {}, _defineProperty(_classnames4, "".concat(classes.drawerPaperUnder), !smallScreen && rightDrawerUnder), _defineProperty(_classnames4, "".concat(classes.rightDrawerDockedFix), isDocked(rightDrawerType)), _classnames4));
  var drawerHeaderClassnames = (0, _classnames6.default)((_classnames5 = {}, _defineProperty(_classnames5, "".concat(classes.drawerHeader), !usingTwoRowAppBar), _defineProperty(_classnames5, "".concat(classes.drawerHeaderTwoRowAppBar), usingTwoRowAppBar), _classnames5)); // FIXME find a better way to inject the closeDrawer prop

  var leftDrawerContentWithProps = leftDrawerContent ? React.cloneElement(leftDrawerContent, _objectSpread({
    closeDrawer: handleLeftDrawerClose,
    closeDrawerOnClick: smallScreen || leftDrawerType === 'temporary'
  }, leftDrawerContent.props)) : leftDrawerContent;
  var rightDrawerContentWithProps = rightDrawerContent ? React.cloneElement(rightDrawerContent, _objectSpread({
    closeDrawer: handleRightDrawerClose,
    closeDrawerOnClick: smallScreen || rightDrawerType === 'temporary'
  }, rightDrawerContent.props)) : rightDrawerContent;
  return React.createElement(_LayoutActions.default.Provider, {
    value: layoutActions
  }, React.createElement("div", {
    className: classes.layout
  }, appBarContent ? React.createElement(_AppBar.default, _extends({
    position: appBarPosition,
    toggleLeftDrawer: toggleLeftDrawer,
    toggleRightDrawer: toggleRightDrawer,
    className: appBarClassnames
  }, appBarProps), appBarContent) : null, leftDrawerContentWithProps ? React.createElement(_Drawer.default, _extends({
    open: leftDrawerOpen,
    onClose: handleLeftDrawerClose,
    variant: !smallScreen ? leftDrawerType : 'temporary',
    classes: {
      paper: leftDrawerPaperClassnames
    }
  }, leftDrawerProps), !smallScreen && leftDrawerUnder ? React.createElement("div", {
    className: drawerHeaderClassnames
  }) : null, leftDrawerContentWithProps) : null, rightDrawerContentWithProps ? React.createElement(_Drawer.default, _extends({
    anchor: "right",
    open: rightDrawerOpen,
    onClose: handleRightDrawerClose,
    variant: !smallScreen ? rightDrawerType : 'temporary',
    classes: {
      paper: rightDrawerPaperClassnames
    }
  }, rightDrawerProps), !smallScreen && rightDrawerUnder ? React.createElement("div", {
    className: drawerHeaderClassnames
  }) : null, rightDrawerContentWithProps) : null, React.createElement("main", {
    className: mainClassnames
  }, children), footerContent ? React.createElement(_Footer.default, _extends({}, footerProps, {
    className: footerClassnames
  }), footerContent) : null));
};

Layout.defaultProps = {
  title: '',
  appBarPosition: 'fixed',
  stickyFooter: false,
  leftDrawerOpen: false,
  leftDrawerUnder: false,
  rightDrawerOpen: false,
  rightDrawerUnder: false,
  mainGrow: true,
  usingTwoRowAppBar: false
};

var _default = (0, _withStyles.default)(_styles.default)(React.memo(Layout));

exports.default = _default;